const SELECTOR = '.js-cognito-form';

let cache = null;

function cognitoForms() {
    if (cache !== null) {
        return cache;
    }

    cache = new Promise(resolve => { // eslint-disable-line compat/compat
        const script = document.createElement('script');

        script.onload = function () {
            resolve(window.Cognito);
        }

        script.src = 'https://www.cognitoforms.com/f/seamless.js';

        document.head.appendChild(script);
    });

    return cache;
}

export function init() {
    document.querySelectorAll(SELECTOR).forEach(element => {
        cognitoForms().then(Cognito => {
            const { key, form } = element.dataset;

            const inner = element.querySelector('.js-cognito-form--embed');

            Cognito(key).mount(form, inner);
        });
    });
}
